import { render, staticRenderFns } from "./EditDebateTeamsContainer.vue?vue&type=template&id=0efbccac&"
import script from "./EditDebateTeamsContainer.vue?vue&type=script&lang=js&"
export * from "./EditDebateTeamsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports